import React from 'react'
import { Badge, Whisper, Tooltip } from 'rsuite'
import { Cell } from 'rsuite-table'

type RowData = {
  [key: string]: string | boolean
}

type QuotationStatusCellProps = {
  rowData?: RowData
  dataKey: string
}

const defaultProps = {
  rowData: undefined
}

const STATUS_CONFIG: Record<
  string,
  { label: string; bg: string; color: string }
> = {
  GENERATED: { label: 'Generated', bg: '#E8F4FD', color: '#1976D2' },
  IN_PROGRESS: { label: 'In Progress', bg: '#FFF8E1', color: '#F9A825' },
  ACCEPTED: { label: 'Accepted', bg: '#ECFDF3', color: '#14BA6D' },
  EXPIRED: { label: 'Expired', bg: '#E9EDF5', color: '#6C778B' },
  REJECTED: { label: 'Rejected', bg: '#FDE8E8', color: '#D32F2F' },
  CONVERTED: { label: 'Converted', bg: '#EDE7F6', color: '#7B1FA2' }
}

const FALLBACK_CONFIG = { label: '-', bg: '#E9EDF5', color: '#6C778B' }

const QuotationStatusCell: React.FC<QuotationStatusCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const status = rowData?.[dataKey] as string
  const config = STATUS_CONFIG[status] ?? {
    ...FALLBACK_CONFIG,
    label: status ?? '-'
  }

  return (
    <Whisper
      placement="bottom"
      trigger="hover"
      speaker={<Tooltip>{config.label}</Tooltip>}
    >
      <Cell {...props}>
        <Badge
          style={{
            backgroundColor: config.bg,
            color: config.color,
            padding: '3px 10px 3px 5px',
            whiteSpace: 'nowrap'
          }}
          content={
            <>
              <Badge
                style={{ backgroundColor: config.color, margin: '0 7px' }}
              />
              {config.label}
            </>
          }
        />
      </Cell>
    </Whisper>
  )
}

QuotationStatusCell.defaultProps = defaultProps

export default QuotationStatusCell
